import React,{useState, useCallback, useEffect} from 'react'
import {Link} from 'react-router-dom'
import { Table, Container } from 'react-bootstrap';

const Leaderboard = ({location}) =>{
    const [contestId, setContestId] = useState()
    const [leaderboardData, setLeaderboardData] = useState([])
    const [loader, setLoader] = useState(true)

    const loadData = useCallback(async () =>{
        setLoader(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UCI")
        setContestId(temp2)
        const response = await fetch(`https://codezap-e156b.firebaseio.com/contests/${temp2}/participants.json`)
        const resData = await response.json()
        var Map = {}
        var resultArr = []
        if(resData){
            var arr = []
            for(var keys in resData){
                var sEmails =keys.split("@") 
                var  use =sEmails[0].replace('"dot"',".")
                
                var s = 0
                var totalTime = 0
                for (var key in resData[keys]){
                    if(resData[keys][key]["score"])
                    {s = s + resData[keys][key]["score"];}
                    if(resData[keys][key]["time"]){
                    totalTime += resData[keys][key]["time"]["seconds"] +  resData[keys][key]["time"]["minutes"]*60 +  resData[keys][key]["time"]["hours"]*3600}
                    
                }
                if(Map[s]){
                    Map[s].push({totalTimeInSeconds:totalTime, userId: use})
                }else{
                    Map[s] = [{totalTimeInSeconds:totalTime, userId: use}]
                }
                arr.push(s)

            }
            
        }
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
          }
        arr = arr.sort().reverse().filter(onlyUnique);
        

        
        for(var i in arr){
            var candidate = Map[arr[i]]
            if(candidate.length < 1){
                resultArr.push([candidate[0]["userId"],arr[i]])
            }
            else{
                candidate = candidate.sort((a, b) => (a.totalTimeInSeconds) - (b.totalTimeInSeconds))
                
                for(var j in candidate){
                    resultArr.push([candidate[j]["userId"], arr[i]])
                }


            }
        }
        setLeaderboardData(resultArr)
        setLoader(false)
        
        
        
        
    },[location.search])


    useEffect(() =>{
        loadData()
    },[loadData])
    return (
        <section className = "hero">

            <header className="mb-4 shadow">
                <nav className="navbar navbar-dark bg-dark primary-styled-border">
                    <div className="container">
                        <Link to = {"/contest?UCI="+contestId} style = {{color:"white"}}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style = {{fontSize:"40px"}}></i>
                        </Link>
                        <div>
                        
                        
                        {loader ? <p></p>:<h1 style = {{color:"white"}}> {contestId.split("_").join(" ").substring(0, contestId.split("_").join(" ").length - 4)}</h1>}
                        </div>
                    </div>
                </nav>
            </header> 
            <Container style = {{marginTop:"3%"}}>
            <h1>Leaderboard</h1>
            {
                loader ? <p></p>:
                <Table striped bordered hover>
                    <thead>
                        <tr>
                        <th>Rank</th>
                        <th>Username</th>
                        <th>Score</th>
                        <th>time</th>
                        </tr>
                    </thead>
                    <tbody>
                        { leaderboardData.map((item,key) => 
                                <tr key = {key}>
                                <td>{key+1}</td>
                                <td>{item[0]}</td>
                                <td>{item[1]}</td>
                                <td>@mdo</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            }
            
            </Container>
            
            
        </section>
    )
}

export default Leaderboard